import { Injectable } from '@angular/core';
import { LoginUserData } from '../clients/system-api/SystemApiClient';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() { }
  getClientId() {
    localStorage.getItem("clientId");
  }

  setClientId(clientId: string) {
    localStorage.setItem("clientId", clientId);
  }

  setProfile(userData: LoginUserData) {
    localStorage.setItem("profile", JSON.stringify(userData));
  }

  getProfile(): LoginUserData {
    return JSON.parse(localStorage.getItem("profile")!);
  }

  //CHANGED SESSION STORAGE TO LOCAL STORAGE
}
